import {Button, Checkbox, Form, Input} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import React from "react";

interface AccountLoginFormProps {
    setLogin: (login: string) => void,
    setPassword: (password: string) => void,
    handleLogin: () => void
}

const AccountLoginForm = (
    {
        setLogin,
        setPassword,
        handleLogin,
    }: AccountLoginFormProps
) => {
    return (
        <Form
            name="login_form"
            initialValues={{remember: true}}
            onFinish={() => {
            }}
            layout="vertical"
            size="large"
        >
            <Form.Item
                label="Логин"
                name="login"
                rules={[{required: true, message: 'Введите логин!'}]}
            >
                <Input prefix={<UserOutlined/>}
                       placeholder="Логин"
                       onChange={(e) => setLogin(e.target.value)}
                />
            </Form.Item>

            <Form.Item
                label="Пароль"
                name="password"
                rules={[{required: true, message: 'Введите пароль!'}]}
            >
                <Input.Password prefix={<LockOutlined/>} placeholder="Пароль"
                                onChange={(e) => setPassword(e.target.value)}/>
            </Form.Item>

            <Form.Item name="remember" valuePropName="checked" style={{marginBottom: 0}}>
                <Checkbox>Запомнить меня</Checkbox>
            </Form.Item>

            <Form.Item style={{marginTop: 24}}>
                <Button type="primary" htmlType="submit" block onClick={handleLogin}>
                    Войти
                </Button>
            </Form.Item>
        </Form>
    );
};

export default AccountLoginForm;